// The CRM ships no service worker. This module only removes one.
//
// removeServiceWorker() runs on every load: it unregisters every registration
// on this origin and deletes every Cache Storage entry (the old worker's
// quote-app-v3 / quote-app-data-v3). The POS is a separate origin, so its own
// worker and caches are out of reach. A device the old worker still controls
// never runs this code; public/service-worker.js is the kill switch for those.

export async function removeServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    } catch (error) {
      console.error('Service worker unregister failed:', error);
    }
  }

  if ('caches' in window) {
    try {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((key) => window.caches.delete(key)));
    } catch (error) {
      console.error('Cache Storage purge failed:', error);
    }
  }
}

// Check if app is running in standalone mode (installed as PWA)
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

// Detect if device is iOS
export function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !window.MSStream
  );
}
